export type VideoMeetingDTO = {
  roomName: string;
  token: string;
  domain: string;
};

export const parseVideoMeetingDTO = (videoMeetingDTO: VideoMeetingDTO) => {
  return {
    roomName: videoMeetingDTO.roomName,
    token: videoMeetingDTO.token,
    domain: videoMeetingDTO.domain,
  };
};
